import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import journey from "../data/journey";
import "../styles/pages/about.css";

export default function Home() {
  return (
    <>
      <Navbar />
      <div className="about">
        <div className="about__container">
          <div className="about__hero">
            <h1>Let Me Introduce Myself </h1>
            <p>Learn more about my background, skills, and journey.</p>
          </div>
          <div className="about__body">
            <span className="about__timeline-shape"></span>
            {journey.map((jor) => {
              return (
                <div className={`about__body-row ${jor.type}`}>
                  <div className="about__body-item about__body-item--content">
                    <div className="pointer-holer">
                      <span className="pointer"></span>
                      <span className="pointer-shape"></span>
                      <span className="pointer-layer"></span>
                      <span className="pointer-highlighter"></span>
                    </div>
                    <div className="about__body-item__info">
                      <div className="about__body-item__info-wrapper">
                        <h2>{jor.title}</h2>
                        <p> {jor.desc} </p>
                      </div>
                      <div className="about__body-item__tags">
                        {jor.tags.map((tag) => {
                          return <span>{tag}</span>;
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="about__body-item about__body-item--summery">
                    <h3>{jor.year}</h3>
                    <h5>{jor.location}</h5>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
